import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SysReturnList } from '../interfaces/SysReturnList.interfaces';

/**
 * Service per la gestione di Sys_Return_List.
 * Mappato sul backend: /api/sys-return-list
 *
 * Il token JWT viene aggiunto automaticamente dall'AuthInterceptor.
 */
@Injectable({
  providedIn: 'root'
})
export class SysReturnListService {
  private baseUrl = `${environment.apiUrl}/sys-return-list`;

  constructor(private http: HttpClient) {}

  /**
   * Recupera tutti i record Sys_Return_List.
   */
  getAll(): Observable<SysReturnList[]> {
    return this.http.post<SysReturnList[]>(`${this.baseUrl}/getAll`, {});
  }

  /**
   * Inserisce un nuovo record Sys_Return_List.
   */
  insert(dto: SysReturnList): Observable<SysReturnList> {
    return this.http.post<SysReturnList>(`${this.baseUrl}/insert`, dto);
  }

  /**
   * Aggiorna un record Sys_Return_List esistente.
   *
   * @param id  Identificativo del record da aggiornare
   * @param dto Nuovi dati del record
   */
  update(id: number, dto: SysReturnList): Observable<SysReturnList> {
    return this.http.post<SysReturnList>(`${this.baseUrl}/update/${id}`, dto);
  }
}
